import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import Product from "../Product/Product";
import "./Products.css";

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://young-hamlet-12954.herokuapp.com/products")
      .then((res) => res.json())
      .then((data) => {
        setProducts(data);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Spinner animation="border" variant="danger" className="text-center" />
    );
  }

  return (
    <div className="products">
      <div className="container pt-5 pb-5">
        <h6 className="text-center">Choose Your Colour</h6>
        <h2 className="text-center">
          Select Your Best Choice <br />
          To Colour Your Lips
        </h2>
        <div className="row g-5">
          {products.slice(0, 6).map((product, index) => (
            <Product key={index} product={product}></Product>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;
